export default function BannerText() {
    return (
        <div className="banner-text">
            <h1>Smart Monopoly Game</h1>
            <p className="kabel-reg-24">First smart-contract based<br className="bp2-hide" /> Monopoly - Play2Earn game </p>
        </div>
    )
}